<div class="weeks-period">
	<p class="days-of-week-label" [class.error-label]="selectedDaysError">
		{{ 'repeat_on' | translate }}
	</p>
	<div class="days-options-wrapper">
		@for (day of nameOfTheDay; track day) {
			<span
				class="day-option"
				(click)="toggleDaySelection(day)"
				[class.selected]="isDaySelected(day)"
			>
				{{ day[0] | uppercase }}
			</span>
		}
	</div>
</div>
